<template>
  <div class="mb-5">
    <template v-if="type == 'areaaccountingproduct'">
      <div class="text-end mb-3">
        <v-btn @click="exportAreaAccounting()" class="blue white--text" :disabled="isMainLoading">
          <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
        </v-btn>
      </div>
    </template>
    <div class="text-end mb-2" v-if="type == 'billing' || type == 'water' || type == 'elec'">
      <v-btn v-if="!isShowSelect" class="blue white--text mx-1" :disabled="isMainLoading" @click="seleteArea()">
        <v-icon class="me-2">mdi-cog</v-icon>
        <template v-if="type == 'billing'">{{ $t('market.setting_multiple_stall') }}</template>
        <template v-else>{{ $t('meter.setting_multiple_meter') }}</template>
      </v-btn>
      <template v-if="isShowSelect">
        <v-btn v-if="type == 'billing'" class="blue white--text mx-1" :disabled="isMainLoading || seleteAreas.length == 0"
          @click="addBillingSettings()">
          <v-icon class="me-2">mdi-plus</v-icon>
          {{ $t('market.setting_all_stall', { count: seleteAreas.length }) }}
        </v-btn>
        <v-btn v-else class="blue white--text mx-1" :disabled="isMainLoading || seleteMeters.length == 0"
          @click="addBillingSettings()">
          <v-icon class="me-2">mdi-plus</v-icon>
          {{ $t('market.setting_all_meter', { count: seleteMeters.length }) }}
        </v-btn>
        <v-btn class="error mx-1" :disabled="isMainLoading"
          @click="seleteAreas = []; seleteMeters = []; isShowSelect = false">{{ $t('cancel') }}</v-btn>
      </template>
    </div>
    <div class="text-start mb-2" v-if="type == 'settingtask'">
      <v-btn class="blue white--text mx-1"
        :disabled="isMainLoading || settingTaskSelector.length <= 0 || !enableSendApproveBillingSetting"
        @click="isSendSettingTask = true; currentNote = ''">
        <template>{{ $t('appeal.send_appeal') }} {{ `${settingTaskSelector.length ? settingTaskSelector.length + ` ${$t('list')}` :
          ''}` }}</template>
      </v-btn>
      <v-btn color="error" :disabled="isMainLoading || settingTaskSelector.length <= 0"
        @click="isRemoveSettingTask = true">
        <template>{{ $t('action_type.delete') }} {{ `${settingTaskSelector.length ? settingTaskSelector.length + ` ${$t('list')}` : ''}` }}</template>
      </v-btn>
    </div>
    <v-card flat outlined :loading="isMainLoading" min-height="30">
      <v-data-table
        v-if="type == 'water' || type == 'elec'"
        :loading="isBillingLoading || isMainLoading"
        v-model="seleteMeters"
        :items-per-page="50"
        :headers="headers"
        :items="!isBillingLoading ? settings : []"
        class="elevation-0 outlined"
        sort-by="area.name"
        item-key="objectId"
        :show-select="isShowSelect"
        :no-data-text="$t('noinfo')"
        :no-results-text="$t('no_matching_records_found')">
        <template v-slot:item.objectId="{ item }">
          <div class="flex justify-end">
            <v-btn color="info" elevation="0" rounded small @click="addBillingSetting(item.area, 'facility', item)">
              <v-icon left>mdi-plus</v-icon>{{ $t('add_setting') }}
            </v-btn>

            <v-btn color="error" :disabled="item.isMain" text @click="selectRemoveMeter(item.objectId)">
              <v-icon left>mdi-close</v-icon>{{ $t('meter.delete_meter') }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item.cost="{ item }">
          <div class="flex-col my-2" v-for="(bill, index) in getBillingByMeterId(item.objectId)" :key="`bill${index}`">
            <div class="items-center d-flex">
              <span class="w-56">{{ bill.accountingProduct.name }}</span>
              {{ bill.cost | currencySuffixTextThEn }} /
              {{ bill.typeString }}
              <v-btn color="warning" icon @click="selectUpdate(bill, 'facility', null, item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn color="error" icon @click="removeDialogId(bill.objectId, bill)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="flex items-center">
            <div>
              <span right class="px-3 rounded info white--text" v-if="!item.isMain">{{ $t('additional') }}</span>
              <!--slot can be any component-->
              {{ item.isMain ? (item.name ? item.name : $t('main')) : item.name }}
            </div>
            <v-btn color="warning" icon @click="openEditDialog(item)">
              <v-icon size="15">mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <v-data-table
        v-if="type == 'billing'"
        :loading="isBillingLoading || isMainLoading"
        v-model="seleteAreas"
        :items-per-page="50"
        :headers="billingTable.headers"
        :items="!isBillingLoading ? getAreas : []"
        class="elevation-0 outlined"
        sort-by="area.name"
        item-key="objectId"
        :show-select="isShowSelect"
        :no-data-text="$t('noinfo')"
        :no-results-text="$t('no_matching_records_found')">
        <template v-slot:item.billingSetting="{ item }">
          <td>
            <tr v-for="(prod, index) in getBillingByAreaId(item.objectId)" :key="`${item.objectId}_${index}`">
              <td width="200" class="py-2 w-52">
                <span class="nameProd">{{ prod.accountingProduct.name }}</span>
              </td>
              <td width="150" class="px-2 py-2 text-right">{{ prod.cost | currency }}</td>
              <td width="150" class="py-2">{{ $helper.currencyThEn() }} / {{ prod.typeString }}</td>
              <td class="py-2">
                <span></span>
                <v-btn color="yellow darken-2" icon @click="selectUpdate(prod, 'service', item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="error" icon @click="removeDialogId(prod.objectId, prod)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </td>
            </tr>
            <span v-if="getBillingByAreaId(item.objectId).length < 1"
              class="px-3 warning rounded-xl white--text">{{ $t('not_setting') }}</span>
          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn color="info" small rounded elevation="0" @click="addBillingSetting(item, 'service')">
            <v-icon left>mdi-plus</v-icon>{{ $t('add_setting') }}
          </v-btn>
        </template>
      </v-data-table>
      <template v-if="type == 'area'">
        <MarketPlan :isEdit="true" />
      </template>
      <!-- <v-data-table
        v-if="type == 'area'"
        :items-per-page="50"
        :headers="areasSettingTable.headers"
        :items="areasSettingTable.items"
        :search="searchArea"
        class="elevation-0 outlined"
        sort-by="name"
      >
        <template v-slot:item.size="{ item }">
          {{ item.size | currency }}
        </template>
        <template v-slot:item.manage="{ item }">
          <div class="d-flex justify-end">
            <v-btn text color="yellow darken-2" @click.stop="editArea(item)"
              ><v-icon left>mdi-pencil</v-icon>แก้ไข</v-btn
            >
            <v-btn text color="error" @click.stop="dialogRemoveArea(item)"
              ><v-icon left>mdi-trash-can-outline</v-icon>ลบ</v-btn
            >
          </div>
        </template>
      </v-data-table>-->
      <v-data-table
        v-if="type == 'areaaccountingproduct'"
        :items-per-page="50"
        :headers="areasAccountingTable.headers"
        :items="areasAccountingTable.items"
        :search="searchArea"
        class="elevation-0 outlined"
        sort-by="name"
        :loading="isLoading"
        :no-data-text="$t('noinfo')"
        :no-results-text="$t('no_matching_records_found')">
        <template v-slot:item="{ item }">
          <tr :data-id="item.id">
            <td class="text-center fix-col">{{ item.area.name }}</td>
            <template v-for="header, index in areasAccountingTable.headers">
              <template v-if="header.value !== 'area.name' && header.value !== 'action'">
                <td class="text-center" :key="index" width="100px">
                  <template v-if="item[header.value]">
                    <template v-if="item[header.value].cost">{{ item[header.value].cost | currency }}</template>
                    <v-btn text icon small @click="updateAreaAccountingProuctDialog(item[header.value])">
                      <v-icon dense>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <v-btn v-else text icon small @click="addAreaAccountingProduct(item.area, header.value)">
                    <v-icon dense>mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </template>
            </template>
          </tr>
        </template>
      </v-data-table>
      <div v-if="type == 'bill' && !isLoading">
        <v-card class="mb-2" elevation="0">
          <v-card-title>{{ $t('bill.bill_detail') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <span>{{ $t('market.company_name') }}</span>
                <v-text-field v-model="formBill.companyData.name" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('market.company_address') }}</span>
                <v-text-field v-model="formBill.companyData.address" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('tax.tax_id_number') }}</span>
                <v-text-field v-model="formBill.companyData.taxId" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('address.company_branch') }}</span>
                <v-text-field v-model="formBill.companyData.branchName" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="6">
                <span>{{ $t('market.company_tel') }}</span>
                <v-text-field v-model="formBill.companyData.tel" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="6">
                <span>{{ $t('market.company_email') }}</span>
                <v-text-field v-model="formBill.companyData.email" flat background-color="grey lighten-4" solo
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card elevation="0">
          <v-card-title>
            {{ $t('invoice.invoice_footer_note') }}
            <b style="text-decoration: underline;" class="ms-2">{{ $t('invoice.title') }}</b>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="formBill.setting.invoiceNote" flat background-color="grey lighten-4" hide-details
              solo></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn :disabled="isLoading || isSaveing" color="success" @click="saveMarketBill()">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </div>

      <v-data-table
        v-if="type == 'settingtask'"
        :loading="isLoading"
        :items-per-page="50"
        :headers="settingTaskHeaders"
        :items="settingTaskItems"
        :no-data-text="$t('task.no_send_approve_setting')"
        class="elevation-0 outlined"
        sort-by="createdAt"
        :sort-desc="true"
        item-key="objectId"
        :show-select="true"
        v-model="settingTaskSelector"
        @toggle-select-all="selectAllToggle"
        :no-results-text="$t('no_matching_records_found')">
        <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox v-if="checkStatus(item.status)" :value="isSelected"
            @input="select($event)"></v-simple-checkbox>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-simple-checkbox v-bind="attrs" v-on="on" readonly disabled></v-simple-checkbox>
            </template>
            <span>{{ $t('status') }} {{ item.statusString }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.name="{ item }">{{ item.area.name }}</template>
        <template v-slot:item.action="{ item }">{{ item.actionString }}</template>
        <template v-slot:item.currentAccountingProduct="{ item }">{{ item.currentAccountingProductString }}</template>
        <template v-slot:item.previousAccountingProduct="{ item }">{{ item.previousAccountingProductString }}</template>
        <template v-slot:item.createdBy="{ item }">{{ item.createdByFullName }}</template>
        <template v-slot:item.createdAt="{ item }">{{ item.createdAtDateFormat }}</template>
        <template v-slot:item.updatedBy="{ item }">{{ item.updatedByFullName }}</template>
        <template v-slot:item.updatedAt="{ item }">{{ item.updatedBy ? item.updatedAtDateFormat : '-' }}</template>
        <template v-slot:item.status="{ item }">{{ item.statusString }}</template>
      </v-data-table>

      <form-billing-setting v-model="billingDialog" :area="tempArea" @onSave="onSaveBilling"
        @onSaveUpdate="saveUpdateBilling" :billingType="billingType" :event="event" :billingSetting="tempBillingSetting"
        :meter="tempMeter" :meterType="$route.params.settingType" :isLoading="isBillingLoading"></form-billing-setting>
    </v-card>
    <v-dialog v-model="isEditDialog" max-width="400px">
      <v-card v-if="editItem">
        <v-card-title class="justify-between info text-white">
          {{ $t('meter.edit_meter') }}
          <v-btn color="white" icon @click="isEditDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="bg-white px-5 pt-4">
          <span>{{ $t('meter.meter_name') }}</span>
          <v-text-field v-model="editItem.name" solo flat background-color="grey lighten-4" hide-details></v-text-field>
        </div>
        <div class="flex justify-end p-5">
          <!-- v-btn elevetion-0 -->
          <v-btn color="primary" elevation="0" @click="saveEditItem()" :disabled="isSaveing"
            :loading="isEditLoading">{{ $t('save') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <confirm-dialog @onOk="removeBilling(removeId)" v-model="removeDialog" :disabled="isLoading"
      :loading="isLoading"></confirm-dialog>
    <confirm-dialog v-model="removeMeterDialog" @onOk="removeMeter(removeId)"></confirm-dialog>
    <confirm-dialog v-model="isRemoveAreaDialog" v-if="tempArea"
      :title="`${$t('validate.want_delete_sale_stall', { name: tempArea.name })}`" :disabled="isSaveing"
      @onOk="removeArea()"></confirm-dialog>
    <confirm-dialog v-model="isRemoveSettingTask" v-if="settingTaskSelector && settingTaskSelector.length"
      :title="`${$t('task.you_want_to_delete_approve_setting', { count: settingTaskSelector.length })}`"
      :disabled="isSaveing" @onOk="removeSettingTask()"></confirm-dialog>
    <AreaManageDialog v-model="isAreaManageDialog" :market="market" :area="tempArea" type="edit" />
    <AreaAccountingProductManageDialog v-model="isAreaAccProductManageDialog" :marketId="market.objectId"
      :projectId="project.objectId" :area="tempArea" :areaAccountingProduct="tempAreaAccountingProduct"
      :areaAccountingProducts="tempArea && hashAreaAccByArea[tempArea.objectId] ? hashAreaAccByArea[tempArea.objectId] : []"
      :accountingProduct="tempAccountingProduct" @onSaveSuccess="onSaveAreaAccSuccess" />
    <LoadingPercentDialog v-model="isLoadingDialog" :final="loadingFinal" :initial="loadingInitial" />
    <v-dialog v-model="isSendSettingTask" persistent max-width="600px">
      <v-card v-if="settingTaskSelector && settingTaskSelector.length">
        <v-card-title class="primary--text">{{ $t('task.you_want_to_send_approve_setting', { count: settingTaskSelector.length }) }}</v-card-title>
        <v-card-text class="py-5">
          <p class="mb-3">
            <b>{{ $t('note_if_have') }}</b>
          </p>
          <v-textarea v-model="currentNote" :placeholder="$t('note_if_have_placeholder')" :label="$t('note')" class="mb-2" outlined dense
            hide-details rows="2" no-resize></v-textarea>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn @click="isSendSettingTask = false" :disabled="isLoading">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" @click="sendSettingTask()" :loading="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isGotoSendSettingTask" persistent max-width="400px">
      <v-card>
        <v-card-title class="primary--text">{{ $t('task.create_approve_setting_success') }}</v-card-title>
        <v-card-text class="py-5">
          <div style="text-indent:15px;">{{ $t('task.create_approve_setting_success_description_1') }}
          </div>
          <div style="text-indent:15px;">{{ $t('task.create_approve_setting_success_description_3') }}</div>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn @click="isGotoSendSettingTask = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" to="settingtask" @click="isGotoSendSettingTask = false">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('task.goto_approve_setting_task') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import ConfirmDialog from "./ConfirmDialog.vue";
import FormBillingSetting from "./FormBillingSetting.vue";
import AreaManageDialog from "./AreaManageDialog.component.vue";
import AreaAccountingProductManageDialog from "./AreaAccountingProductManageDialog.component.vue";
import { ExportMarketSetting } from "../exports";
import LoadingPercentDialog from "./LoadingPercentDialog.component";
import { Market, MarketSetting } from "../classes";
import MarketPlan from "./MarketPlan.vue";
export default {
  components: {
    FormBillingSetting,
    ConfirmDialog,
    AreaManageDialog,
    AreaAccountingProductManageDialog,
    LoadingPercentDialog,
    MarketPlan
  },
  props: {
    type: String,
    settings: Array,
    isMainLoading: Boolean,
    market: Object,
    searchArea: String,
    project: Object,
    marketId: String
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    ...mapGetters({
      billingSetting: "billingSetting/getBillingSettingsWithLabel",
      getAreas: "markets/getAreas",
      getSettingTasks: "settingTask/getSettingTasks"
    }),
    ...mapState({
      areas: state => state.area.areas,
      areaAccountingProducts: state =>
        state.areaAccountingProduct.areaAccountingProducts,
      accountingProducts: state => state.accountingProducts.accountingProducts
    }),
    areasSettingTable() {
      return {
        headers: [
          {
            text: this.$t('area.stall_name_and_number'),
            value: "name"
          },
          {
            text: this.$t('area.area_size_square_meter_space'),
            value: "size"
          },
          {
            text: "",
            value: "manage",
            sortable: false
          }
        ],
        items: this.areas
      };
    },
    settingTaskItems() {
      this.settingTaskSelector = [];
      let data = [];
      if (this.getSettingTasks) this.disabledCount = 0;
      for (const settingTask of this.getSettingTasks) {
        if (this.checkStatus(settingTask.status)) data.push(settingTask);
        else this.disabledCount += 1;
      }
      return data;
    },
    enableEditBillingSetting() {
      let res = false;
      if (
        this.admin ||
        (this.employee && this.employee.enableEditBillingSetting)
      ) {
        res = true;
      }
      return res;
    },
    enableSendApproveBillingSetting() {
      let res = false;
      if (
        this.admin ||
        (this.employee && this.employee.enableSendApproveBillingSetting)
      ) {
        res = true;
      }
      return res;
    }
  },
  data() {
    return {
      headers: [],
      billingTable: {
        headers: []
      },
      settingTaskHeaders: [],
      currentNote: "",
      removeAreaId: "",
      settingTaskSelector: [],
      isSendSettingTask: false,
      isRemoveSettingTask: false,
      billingDialog: false,
      obj: {},
      billingType: "",
      event: "",
      tempBillingSetting: {},
      removeId: "",
      removeDialog: false,
      tempMeter: {},
      removeMeterDialog: false,
      isBillingLoading: false,
      tempArea: null,
      isAreaManageDialog: false,
      isRemoveAreaDialog: false,
      isGotoSendSettingTask: false,
      isSaveing: false,
      editItem: {},
      isEditDialog: false,
      isEditLoading: false,
      isAreaAccProductManageDialog: false,
      areasAccountingTable: {},
      hashAreaAccByArea: {},
      tempAreaAccountingProduct: null,
      tempAccountingProduct: null,
      isShowSelect: false,
      seleteAreas: [],
      seleteMeters: [],
      isLoadingDialog: false,
      loadingInitial: 0,
      loadingFinal: 0,
      isLoading: false,
      formBill: null,
      isSuccess: false,
      isError: false
    };
  },
  watch: {},
  created() {
    this.initData(this.$route.params.settingType);

    this.headers = [
        {
          value: "area.name",
          text: this.$t('area.stall_code')
        },
        {
          value: "name",
          text: this.$t('meter.meter_name')
        },
        {
          value: "cost",
          text: this.$t('payment.service_cost')
        },
        {
          value: "objectId",
          text: "",
          sortable: false
        }
    ];

    this.billingTable.headers = [
          {
            value: "name",
            text: this.$t('area.area_name')
          },
          {
            value: "billingSetting",
            text: this.$t('area.service')
          },
          {
            value: "action",
            text: ""
          }
    ];

    this.settingTaskHeaders = [
        {
          align: "center",
          value: "name",
          text: this.$t('area.area_name')
        },
        {
          align: "center",
          value: "action",
          text: this.$t('market.action')
        },
        {
          align: "center",
          value: "previousAccountingProduct",
          text: this.$t('market.list_before_change')
        },
        {
          align: "center",
          value: "currentAccountingProduct",
          text: this.$t('market.list_after_change')
        },
        {
          align: "center",
          value: "createdBy",
          text: this.$t('created_by')
        },
        {
          align: "center",
          value: "createdAt",
          text: this.$t('created_at')
        },
        {
          align: "center",
          value: "updatedBy",
          text: this.$t('change_status_by')
        },
        {
          align: "center",
          value: "updatedAt",
          text: this.$t('change_status_at')
        },
        {
          align: "center",
          value: "status",
          text: this.$t('status')
        }
    ];
  },
  methods: {
    async initData(settingType) {
      this.isLoading = true;
      try {
        if (settingType == "areaaccountingproduct") {
          await this.$store.dispatch(
            "accountingProducts/getAccountingProducts",
            this.project.objectId
          );
          await this.$store.dispatch(
            "areaAccountingProduct/getAreaAccountingProductByMarket",
            this.market.objectId
          );
          this.prepareAreaAccountingProduct();
        } else if (settingType == "bill") {
          let market = await Market.getMarket(this.market.objectId);
          let companyData = market.companyData || {};
          let setting = market.setting || {};
          this.formBill = {
            companyData: {
              name: companyData.name || "",
              address: companyData.address || "",
              taxId: companyData.taxId || "",
              branchName: companyData.branchName || "",
              tel: companyData.tel || "",
              email: companyData.email || ""
            },
            setting: {
              marketId: market.objectId || "",
              id: setting.objectId || "",
              invoiceNote: setting.invoiceNote || ""
            }
          };
        } else if (settingType == "settingtask") {
          await this.getSettingTasksData();
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    prepareAreaAccountingProduct() {
      this.hashAreaAccByArea = {};
      this.areasAccountingTable.headers = [];
      this.areasAccountingTable.items = [];
      this.areasAccountingTable.headers[0] = {
        text: this.$t('area.stall_name_and_number'),
        value: "area.name",
        width: "140px",
        class: "fix-col",
        cellClass: "fix-col",
        align: "center"
      };

      if (this.accountingProducts && this.accountingProducts.length) {
        for (let accountingProduct of this.accountingProducts) {
          if (accountingProduct.type != "facility") {
            this.areasAccountingTable.headers.push({
              text: accountingProduct.name,
              value: accountingProduct.objectId,
              align: "center",
              width: "150px"
            });
          }
        }
      }

      if (this.areaAccountingProducts && this.areaAccountingProducts.length) {
        for (let areaAccountingProduct of this.areaAccountingProducts) {
          let area = areaAccountingProduct.area;
          if (!this.hashAreaAccByArea[area.objectId])
            this.hashAreaAccByArea[area.objectId] = [];
          this.hashAreaAccByArea[area.objectId].push(areaAccountingProduct);
        }
      }

      if (this.areas && this.areas.length) {
        for (let area of this.areas) {
          let obj = {
            area: area
          };
          if (
            this.hashAreaAccByArea[area.objectId] &&
            this.hashAreaAccByArea[area.objectId].length
          ) {
            for (let areaAccountingProduct of this.hashAreaAccByArea[
              area.objectId
            ]) {
              let accountingProduct = areaAccountingProduct.accountingProduct;
              obj[accountingProduct.objectId] = areaAccountingProduct;
            }
          }
          this.areasAccountingTable.items.push(obj);
        }
      }
    },
    openEditDialog(item) {
      this.editItem = { name: item.name, id: item.objectId };
      this.isEditDialog = true;
    },
    async saveEditItem() {
      try {
        this.isEditLoading = true;
        const data = await this.$store.dispatch(
          "meter/updateMeter",
          this.editItem
        );
        this.$emit("onLoad");
        this.isEditDialog = false;
        this.isEditLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    selectRemoveMeter(id) {
      this.removeId = id;
      this.removeMeterDialog = true;
    },
    removeDialogId(id, bill) {
      this.removeId = id;
      this.removeDialog = true;
      this.removeAreaId = bill.area.objectId;
    },
    async removeMeter() {
      try {
        this.isBillingLoading = true;
        const saveBilling = await this.$store.dispatch("meter/removeMeter", {
          id: this.removeId
        });
        this.isBillingLoading = false;
        this.removeMeterDialog = false;
        this.$emit("onLoad");
      } catch (err) {
        this.isBillingLoading = false;
        this.removeMeterDialog = false;
      }
    },
    async removeBilling() {
      try {
        this.isLoading = true;
        await this.createSettingTask(
          {
            ...{
              action: "remove",
              billingSettingId: this.removeId,
              marketId: this.marketId,
              areaId: this.removeAreaId
            },
            currencyCode: this.tab
          },
          "remove"
        );
        if (
          this.type != "billing" ||
          (this.enableEditBillingSetting && this.type == "billing")
        ) {
          const saveBilling = await this.$store.dispatch(
            "billingSetting/removeBillingSetting",
            { id: this.removeId }
          );
        }
        this.removeDialog = false;
        this.isLoading = false;
        this.removeAreaId = "";
        this.$emit("onLoad");
      } catch (err) {
        this.isLoading = false;
        this.removeDialog = false;
        this.removeAreaId = "";
      }
    },
    selectUpdate(billingSetting, type, area, meter) {
      this.billingType = type;
      this.event = "update";
      this.tempBillingSetting = billingSetting;
      this.tempArea = area;
      this.tempMeter = meter;
      this.isSaveList = false;
      this.billingDialog = true;
    },
    onSaveBilling(formData) {
      if (this.isSaveList) {
        this.saveBillingList(formData);
      } else {
        this.saveBilling(formData);
      }
    },
    async saveBilling(formData) {
      try {
        this.isBillingLoading = true;
        await this.createSettingTask(
          {
            ...formData,
            ...{ action: "add", marketId: this.marketId },
            currencyCode: this.tab
          },
          "add"
        );

        if (
          this.type != "billing" ||
          (this.enableEditBillingSetting && this.type == "billing")
        ) {
          await this.$store.dispatch(
            "billingSetting/createBillingSetting",
            formData
          );
        }
        this.billingDialog = false;
        this.isBillingLoading = false;
        this.$emit("onLoad");
      } catch (err) {
        console.log("error", err);
        this.isBillingLoading = false;
      }
    },
    async saveBillingList(formData) {
      try {
        this.isBillingLoading = true;
        this.isLoadingDialog = true;
        this.loadingInitial = 0;
        this.loadingFinal = 0;
        let postData = formData;
        if (this.type == "billing") {
          this.loadingInitial = this.seleteAreas.length;
          let indexNumber = 0;
          for (let area of this.seleteAreas) {
            indexNumber++;
            postData.areaId = area.objectId;
            let billingSettings = this.getBillingByAreaId(area.objectId);
            let billingSetting = billingSettings.find(
              d => d.accountingProduct.objectId == formData.accountingProductId
            );
            if (billingSetting) {
              postData.id = billingSetting.objectId;
              postData.billingSettingId = billingSetting.objectId;
              if (!this.enableEditBillingSetting) {
                await this.createSettingTask(
                  {
                    ...postData,
                    ...{ action: "edit", marketId: this.marketId },
                    currencyCode: this.tab
                  },
                  "edit",
                  indexNumber == this.seleteAreas.length
                );
              } else {
                await this.$store.dispatch(
                  "billingSetting/updateBillingSetting",
                  {
                    ...postData,
                    currencyCode: this.tab
                  }
                );
              }
            } else {
              if (!this.enableEditBillingSetting) {
                await this.createSettingTask(
                  {
                    ...postData,
                    ...{ action: "add", marketId: this.marketId },
                    currencyCode: this.tab
                  },
                  "add",
                  indexNumber == this.seleteAreas.length
                );
              } else {
                await this.$store.dispatch(
                  "billingSetting/createBillingSetting",
                  {
                    ...postData,
                    currencyCode: this.tab
                  }
                );
              }
            }
            this.loadingFinal++;
          }
        } else {
          this.loadingInitial = this.seleteMeters.length;
          for (let meter of this.seleteMeters) {
            postData.meterId = meter.objectId;
            postData.areaId = meter.area.objectId;
            let billingSettings = this.getBillingByMeterId(meter.objectId);
            let billingSetting = billingSettings.find(
              d => d.accountingProduct.objectId == formData.accountingProductId
            );
            if (billingSetting) {
              postData.id = billingSetting.objectId;
              await this.$store.dispatch(
                "billingSetting/updateBillingSetting",
                {
                  ...postData,
                  currencyCode: this.tab
                }
              );
            } else {
              await this.$store.dispatch(
                "billingSetting/createBillingSetting",
                {
                  ...postData,
                  currencyCode: this.tab
                }
              );
            }
            this.loadingFinal++;
          }
        }
        this.isShowSelect = false;
        this.seleteAreas = [];
        this.seleteMeters = [];

        this.billingDialog = false;
        this.isLoadingDialog = false;
        this.isBillingLoading = false;
        this.$emit("onLoad");
      } catch (err) {
        this.isBillingLoading = false;
      }
    },
    async saveUpdateBilling(value) {
      try {
        this.isBillingLoading = true;
        await this.createSettingTask(
          {
            ...value,
            ...{ action: "edit", marketId: this.marketId }
          },
          "edit"
        );
        if (
          this.type != "billing" ||
          (this.enableEditBillingSetting && this.type == "billing")
        ) {
          const saveBilling = await this.$store.dispatch(
            "billingSetting/updateBillingSetting",
            value
          );
        }
        this.billingDialog = false;
        this.isBillingLoading = false;
        this.$emit("onLoad");
      } catch (err) {
        this.isBillingLoading = false;
      }
    },
    addBillingSetting(area, type, meterObj = {}) {
      this.billingType = type;
      this.event = "create";
      this.tempMeter = meterObj;
      this.tempArea = area;
      this.tempBillingSetting = null;
      this.isSaveList = false;
      this.billingDialog = true;
    },
    getBillingByAreaId(id) {
      const filterArr = this.billingSetting.filter(
        i => i?.area?.objectId === id && i.isRemoved == false
      );

      this.$forceUpdate();
      return filterArr;
    },
    getBillingByMeterId(id) {
      return this.billingSetting.filter(i => i?.meter?.objectId === id);
    },
    editArea(area) {
      this.tempArea = area;
      this.isAreaManageDialog = true;
    },
    dialogRemoveArea(area) {
      this.tempArea = area;
      this.isRemoveAreaDialog = true;
    },
    async removeArea() {
      this.isSaveing = true;
      try {
        await this.$store.dispatch("area/removeArea", this.tempArea.objectId);
        this.isRemoveAreaDialog = false;
        this.isSaveing = false;
      } catch (error) {
        this.isError = true;
        this.isSaveing = false;
      }
    },
    addAreaAccountingProduct(area, accountingProductId) {
      this.tempArea = area;
      this.tempAccountingProduct = this.accountingProducts.find(
        d => d.objectId == accountingProductId
      );
      this.tempAreaAccountingProduct = null;
      this.isAreaAccProductManageDialog = true;
    },
    updateAreaAccountingProuctDialog(areaAcc) {
      this.tempAccountingProduct = areaAcc.accountingProduct;
      this.tempAreaAccountingProduct = areaAcc;
      this.isAreaAccProductManageDialog = true;
    },
    onSaveAreaAccSuccess() {
      this.prepareAreaAccountingProduct();
    },
    exportAreaAccounting() {
      try {
        ExportMarketSetting.exportMarketAreaAccountingProduct(
          this.areas,
          this.accountingProducts,
          this.areaAccountingProducts
        );
      } catch (error) {
        this.isError = true;
      }
    },
    seleteArea() {
      this.seleteAreas = [];
      this.isShowSelect = true;
    },
    addBillingSettings() {
      this.tempArea = null;
      (this.tempMeter = null), (this.tempBillingSetting = null);
      this.event = "create";
      if (this.type == "water" || this.type == "elec") {
        this.billingType = "facility";
      } else {
        this.billingType = "service";
      }
      this.isSaveList = true;
      this.billingDialog = true;
    },
    async saveMarketBill() {
      this.isSaveing = true;
      try {
        if (this.formBill) {
          let marketSettingId;
          if (this.formBill.setting.id) {
            let setting = await MarketSetting.updateMarketSetting(
              this.formBill.setting
            );
            marketSettingId = setting.objectId;
          } else {
            let setting = await MarketSetting.createMarketSetting(
              this.formBill.setting
            );
            marketSettingId = setting.objectId;
            this.formBill.setting.id = setting.objectId;
          }
          await Market.updateMarket({
            id: this.market.objectId,
            companyData: this.formBill.companyData,
            marketSettingId
          });
        }
        this.isSaveing = false;
        this.isSuccess = true;
      } catch (error) {
        this.isSaveing = false;
        this.isError = true;
      }
    },
    checkStatus(status) {
      let res = false;
      if (status == "draft") {
        res = true;
      }
      return res;
    },
    async sendSettingTask() {
      this.isLoading = true;
      this.isLoadingDialog = true;
      this.loadingFinal = 0;
      this.loadingInitial = 1;
      if (this.settingTaskSelector && this.settingTaskSelector.length) {
        let forms = [];
        for (const settingTask of this.settingTaskSelector) {
          let form = Object.assign({}, settingTask);
          if (this.currentNote) {
            form.description = this.currentNote;
          }
          form.status = "pending";
          forms.push(form);
        }
        await this.$store.dispatch("settingTask/updateSettingTasks", forms);
        this.loadingFinal = 1;
        this.initData(this.$route.params.settingType);
      }
      this.isLoading = false;
      this.isSendSettingTask = false;
      this.isLoadingDialog = false;
    },
    async removeSettingTask() {
      this.isLoading = true;
      this.isLoadingDialog = true;
      this.loadingFinal = 0;
      this.loadingInitial = 0;
      if (this.settingTaskSelector && this.settingTaskSelector.length) {
        this.loadingInitial = this.settingTaskSelector.length;
        let forms = [];
        for (const settingTask of this.settingTaskSelector) {
          let form = Object.assign({}, settingTask);
          form.status = "rejected";
          forms.push(form);
          this.loadingFinal++;
        }
        await this.$store.dispatch("settingTask/updateSettingTasks", forms);
        this.initData(this.$route.params.settingType);
      }
      this.isLoading = false;
      this.isRemoveSettingTask = false;
      this.isLoadingDialog = false;
    },
    selectAllToggle(props) {
      if (
        this.settingTaskSelector.length !=
        this.getSettingTasks.length - this.disabledCount
      ) {
        this.settingTaskSelector = [];
        const self = this;
        props.items.forEach(item => {
          if (this.checkStatus(item.status)) {
            self.settingTaskSelector.push(item);
          }
        });
      } else this.settingTaskSelector = [];
    },
    async getSettingTasksData() {
      await this.$store.dispatch("settingTask/getSettingTasks");
    },
    async createSettingTask(formData, action, isLast = true) {
      if (!this.enableEditBillingSetting && this.type == "billing") {
        await this.$store.dispatch("settingTask/createSettingTask", {
          ...formData,
          currencyCode: this.tab
        });
        if (isLast) {
          this.getSettingTasksData();
          this.$toast.show({
            content: `${this.$t('market.setting_invoice_send', { action: action == "add" ? this.$t('action_type.add') : action == "edit" ? this.$t('action_type.edit') : this.$t('action_type.delete') })}`,
            color: "success"
          });
        }
      }
    }
  },
  watch: {
    type(settingType) {
      this.initData(settingType);
      this.isShowSelect = false;
      this.seleteAreas = [];
      this.seleteMeters = [];
    }
  }
};
</script>

<style>
.nameProd {
  font-size: 1rem;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}
</style>